import { useQuery } from "@tanstack/react-query"
import moment from "moment"
import api from "~/api"

import { useCamp } from "~/api2/hooks/useCamp"
import { reservationStatus } from "~/constants"

import { queryKeys } from "~/constants/queryKeys"

type Props = {
  from: moment.Moment
  until: moment.Moment
  except_status?: reservationStatus
  include_recurrences?: boolean
}

export const useReservations = (props: Props) => {
  const {
    index: { data: camp },
  } = useCamp()
  return useQuery({
    queryKey: [queryKeys.RESERVATIONS, camp.id, props.from, props.until],
    queryFn: () =>
      findReservations({
        campId: camp.id,
        from: props.from,
        until: props.until,
        except_status: props.except_status,
        include_recurrences: props.include_recurrences,
      }),
    staleTime: 3000,
    enabled: !!camp.id && !!props.from && !!props.until,
  })
}

const findReservations = async ({
  campId,
  from,
  until,
  except_status,
  include_recurrences,
}: {
  campId: string
  from: moment.Moment
  until: moment.Moment
  except_status?: reservationStatus
  include_recurrences?: boolean
}) => {
  try {
    if (!campId) return
    return await api.fetchReservations({
      camp_id: campId,
      from: from,
      until: until,
      except_status,
      include_recurrences,
    })
  } catch (error) {
    console.error("Error fetching reservations:", error)
    throw error
  }
}
